import {
  Box,
  Flex,
  Link,
  Text,
} from '@chakra-ui/react';
import { TRAFFIC_LIGHT_COLOURS as COLOURS, amenityAndConditionLegend } from '@src/modules/performance/shared/constants';
import { useAchievementsKPI } from '@src/modules/performance/context/map-api-hooks';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import { roundKpiValue } from '@src/modules/performance/shared/helpers';
import IndicatorLegend from '@src/modules/performance/components/IndicatorLegend';
import ReportHeader from './ReportHeader';

const subheader = 'Ride Quality and Road Condition';
const informationSource = {
  title: 'Ride Quality and Road Condition',
  content: [
    {
      title: 'Ride Quality (STE)',
      description:
  <Box mb={2}>
    <Text fontSize="inherit" mb={2}>
      The average annual change in the percentage of vehicle kilometres travelled (VKT) on the network each year on &quot;smooth&quot; sealed roads indicating the ride quality experienced by the user.
    </Text>
    <Text fontSize="inherit" mb={2}>
      The KPI shows a normalised result. Linear regression is used to calculate the raw slope of the STE for the last ten years. The slope is divided by the first year STE value to normalise the growth rate so it is comparable across all networks.
    </Text>
    <Text fontSize="inherit" mb={2}>
      Includes a trend as below:
    </Text>
    <IndicatorLegend items={amenityAndConditionLegend} />
    <Text fontSize="inherit" mt={2}>Road Efficiency Group Te Ringa Maimoa has calculated these results</Text>
  </Box>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools, road condition</Link>
  </Text>,
    },
  ],
};

function RoadConditionReportHeader({ ...rest }) {
  const { data: amenityData, isLoading } = useAchievementsKPI();

  return (
    <ReportHeader
      title="Road Condition"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center">
        <Box mr={3}>
          <CircleIndicator
            size={60}
            colour={COLOURS[amenityData?.colour]}
            value={`${roundKpiValue(amenityData?.value, 5, 1)}%`}
            isLoading={isLoading && !amenityData}
          />
        </Box>
        <Box>
          <Text fontWeight="bold" color="gray" fontSize="sm">
            Ride Quality
            <br />
            (STE) as at
            {' '}
            {amenityData?.lockYear}
          </Text>
        </Box>
      </Flex>
    </ReportHeader>
  );
}

export default RoadConditionReportHeader;
